/** Any occupied interval a candidate span must not overlap. */
export interface SpanAvailableInterval {
  start: Date;
  end: Date;
}

/** Ordering bounds a span must fall within (ISO strings, as carried on
 *  booking state). `null` means unbounded on that side. */
export interface SpanAvailableBounds {
  minStart: string | null;
  maxEnd: string | null;
}

export interface SpanAvailableParams {
  start: Date;
  end: Date;
  /** Injected so "in the past" is testable without wall-clock coupling. */
  now: Date;
  busyBands: SpanAvailableInterval[];
  appointments: SpanAvailableInterval[];
  deviceBands: SpanAvailableInterval[];
  selections: SpanAvailableInterval[];
  bounds: SpanAvailableBounds;
}

/** A full-duration placement is available unless it starts in the past,
 *  overlaps any occupied band, or falls outside the session's ordering
 *  bounds. Touching a band's edge is not overlapping it. */
export function spanAvailable(params: SpanAvailableParams): boolean {
  const { start, end, now, busyBands, appointments, deviceBands, selections, bounds } = params;
  if (start.getTime() < now.getTime()) return false;
  for (const occupied of [...busyBands, ...appointments, ...deviceBands, ...selections]) {
    if (start < occupied.end && end > occupied.start) return false;
  }
  if (bounds.minStart && start < new Date(bounds.minStart)) return false;
  if (bounds.maxEnd && end > new Date(bounds.maxEnd)) return false;
  return true;
}
